import { render } from "./WaimaiCustomer.vue?vue&type=template&id=f65ff5c4&scoped=true"
import script from "./WaimaiCustomer.vue?vue&type=script&lang=js"
export * from "./WaimaiCustomer.vue?vue&type=script&lang=js"

import "./WaimaiCustomer.vue?vue&type=style&index=0&id=f65ff5c4&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65ff5c4"]])

export default __exports__